// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fddfee02","239":"94bf339e","453":"ccfe2960","455":"463d102f"}[chunkId] + ".chunk.js";
};